:host {
  display: block;
  .av-calendar {
    padding: 0.5em;

    > * {
      line-height: 2.5em;
    }

    span,
    .av-calendar-button {
      flex-grow: 30;
      width: calc(100% / 7);
      text-align: center;
      &:focus-visible {
        outline-color: var(--av-color-focus-outline);
      }
    }

    header {
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      font-size: 1.1rem;

      span {
        line-height: 1.8em;
      }

      .av-calendar-button {
        border: 0;
        background: transparent;
        flex-grow: 0.1;
        color: var(--av-card-color);
        cursor: pointer;
        border-radius: 5px;
        transition: all 0.2s ease-out;
        @include darken-on-hover;
        &:after {
          border-radius: var(--av-border-radius-button);
        }
        &:focus-visible {
          outline-color: var(--av-color-focus-outline);
        }
      }
    }

    .day-names {
      display: flex;
      text-transform: uppercase;
      opacity: 0.6;
      font-size: 0.8em;
      font-weight: bold;
    }

    .days-in-month {
      display: flex;
      flex-wrap: wrap;

      span {
        cursor: pointer;
        position: relative;
        &.disabled {
          opacity: 0.3;
          cursor: default;
        }
        &:hover:not(.disabled) i:not(.selected) {
          background: var(--av-color-accent);
          color: var(--av-color-accent-contrast);
          border-radius: var(--av-border-radius-button);
        }
      }

      i {
        padding: 0.6rem;
        font-style: normal;
        position: relative;
        width: 100%;
        &.padding-single-digit {
          padding: 0.6rem 0.8rem;
        }
        &.active {
          border: 2px solid var(--av-color-accent);
          border-radius: var(--av-border-radius-button);
          padding: 0.45rem 0.5rem;
        }
        &.selected {
          background: var(--av-color-accent);
          color: var(--av-color-accent-contrast);
          border-radius: var(--av-border-radius-button);
        }
        &.has-event:before {
          content: " \25CF";
          font-size: 0.7rem;
          position: absolute;
          top: 0.4rem;
          left: 1.18rem;
          color: var(--av-color-accent);
        }
        &.selected.has-event:before {
          color: var(--av-color-accent-contrast);
        }
        &.active.has-event:before {
          top: 0.1rem;
          left: 1.1rem;
        }
      }
    }
  }
}
